import { canv } from "@/canv/global.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class wmLink extends wmBase {
    public name = "wm_link";
    public options: widgetOption<string>[];
    public isLinkTo: boolean;
    public link = "";

    constructor(options: widgetOption<string>[], isLinkTo: boolean) {
        super();
        this.options = options;
        this.isLinkTo = isLinkTo;
    }

    public build(): string {
        const values: string[] = this.options.map((o) => o.value);
        const uniqValues: string[] = Array.from(new Set(values));

        if (
            canv.canvasController.selected.length !== 1 ||
            !canv.canvasController.selected[0].isItemWrapper()
        ) {
            return "";
        }

        let selectedClass = "";
        this.link = "";

        if (uniqValues.length === 1 && uniqValues[0] !== "") {
            selectedClass = "wm_link_selected";
            this.link = uniqValues[0];
        }

        const svg = this.isLinkTo
            ? `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.5 1.5H11.5M16.5 1.5L9 9M16.5 1.5V6.5" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.5 9.83333V14.8333C16.5 15.2754 16.3244 15.6993 16.0118 16.0118C15.6993 16.3244 15.2754 16.5 14.8333 16.5H3.16667C2.72464 16.5 2.30072 16.3244 1.98816 16.0118C1.67559 15.6993 1.5 15.2754 1.5 14.8333V3.16667C1.5 2.72464 1.67559 2.30072 1.98816 1.98816C2.30072 1.67559 2.72464 1.5 3.16667 1.5H8.16667" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round"/>
        </svg>`
            : `
        <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Interface / Link">
            <path id="Vector" d="M9.1718 14.8288L14.8287 9.17192M7.05086 11.293L5.63664 12.7072C4.07455 14.2693 4.07409 16.8022 5.63619 18.3643C7.19829 19.9264 9.7317 19.9259 11.2938 18.3638L12.7065 16.9498M11.2929 7.05L12.7071 5.63579C14.2692 4.07369 16.8016 4.07397 18.3637 5.63607C19.9258 7.19816 19.9257 9.73085 18.3636 11.2929L16.9501 12.7071" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>`;

        return `
          <div class="wm_link ${selectedClass}">
            ${svg}
          </div>
        `;
    }

    public init(): void {
        const item = document.getElementsByClassName("wm_link")[0] as HTMLElement | undefined;
        if (!item) {
            return;
        }
        item.addEventListener("mouseup", this.itemClick.bind(this));
    }

    private itemClick(e: MouseEvent): void {
        const otherSubm = document.getElementsByClassName("widgetSubMenu")[0] as
            | HTMLElement
            | undefined;
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }
        this.applyValue(this.options, this.link);
    }
}
